export default "__VITE_ASSET__DZcoPPGG__"